import React from 'react';
import { Trash2, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const WorkoutDayEditor = ({
  day,
  dayIndex,
  totalDays,
  onUpdateName,
  onAddExercise,
  onUpdateExercise,
  onRemoveExercise,
  onRemoveDay,
}) => {
  const { t } = useTranslation();

  return (
    <div className="workout-day-editor">
      <div className="day-editor-header">
        <div className="day-number-badge">{dayIndex + 1}</div>
        <input
          type="text"
          className="input day-name-input"
          value={day.name}
          onChange={(e) => onUpdateName(dayIndex, e.target.value)}
          placeholder={t('workout.day_placeholder', { number: dayIndex + 1 })}
        />
        {totalDays > 1 && (
          <button
            className="btn btn-icon btn-danger"
            onClick={() => onRemoveDay(dayIndex)}
            style={{ width: '36px', height: '36px', padding: '8px', flexShrink: 0 }}
          >
            <Trash2 size={14} />
          </button>
        )}
      </div>

      {day.exercises.length === 0 && (
        <p className="no-exercises-hint">{t('workout.no_exercises_hint')}</p>
      )}

      {day.exercises.map((exercise, exIndex) => (
        <div key={exIndex} className="exercise-editor-card">
          <div className="exercise-editor-header">
            <span className="exercise-number-label">{t('workout.exercise_number', { number: exIndex + 1 })}</span>
            <button
              className="btn btn-icon btn-danger"
              onClick={() => onRemoveExercise(dayIndex, exIndex)}
              style={{ width: '28px', height: '28px', padding: '6px', flexShrink: 0 }}
            >
              <Trash2 size={12} />
            </button>
          </div>
          <input
            type="text"
            className="input"
            placeholder={t('workout.exercise_name_placeholder')}
            value={exercise.name}
            onChange={(e) => onUpdateExercise(dayIndex, exIndex, 'name', e.target.value)}
          />
          <div className="exercise-fields-row">
            <input
              type="text"
              className="input"
              placeholder={t('workout.sets_placeholder')}
              value={exercise.sets}
              onChange={(e) => onUpdateExercise(dayIndex, exIndex, 'sets', e.target.value)}
            />
            <input
              type="text"
              className="input"
              placeholder={t('workout.notes_placeholder')}
              value={exercise.notes}
              onChange={(e) => onUpdateExercise(dayIndex, exIndex, 'notes', e.target.value)}
            />
          </div>
        </div>
      ))}

      <button
        className="btn btn-sm btn-outline w-full"
        style={{ marginTop: '8px' }}
        onClick={() => onAddExercise(dayIndex)}
      >
        <Plus size={14} />
        {t('workout.add_exercise')}
      </button>
    </div>
  );
};

export default WorkoutDayEditor;
